import {
  MDSButtonSlotName,
  MDSButton,
  MDSIconButton,
  MDSButtonVariant,
} from "@/mds/components/buttons";
import { MDSTooltip, MDSTooltipConfig } from "@/mds/components/tooltip";
import { MDSIcon, MDSIconKind } from "@/mds/components/icon";
import { MDSPanelResponsiveWrapper } from "./panel-responsive-wrapper";

interface Props {
  fullSizeLabel: React.ReactNode;
  fullSizeIcon?: MDSIconKind;
  collapsedIcon: MDSIconKind;
  threshold: string;
  isDisabled?: boolean;
  onClick: () => void;
  tooltipConfig?: MDSTooltipConfig;
  collapsedTooltipConfig?: MDSTooltipConfig;
  variant?: MDSButtonVariant;
}

export function MDSPanelResponsiveButton({
  fullSizeLabel,
  fullSizeIcon,
  collapsedIcon,
  collapsedTooltipConfig,
  threshold,
  isDisabled,
  onClick,
  tooltipConfig,
  variant,
  ...rest
}: Props) {
  return (
    <>
      <MDSPanelResponsiveWrapper minWidth={threshold} {...rest}>
        <MDSTooltip config={tooltipConfig}>
          <MDSButton onClick={onClick} isDisabled={isDisabled} variant={variant}>
            {fullSizeIcon && <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={fullSizeIcon} />}
            {fullSizeLabel}
          </MDSButton>
        </MDSTooltip>
      </MDSPanelResponsiveWrapper>
      <MDSPanelResponsiveWrapper maxWidth={threshold}>
        <MDSTooltip config={collapsedTooltipConfig}>
          <MDSIconButton onClick={onClick} iconKind={collapsedIcon} isDisabled={isDisabled} />
        </MDSTooltip>
      </MDSPanelResponsiveWrapper>
    </>
  );
}
